import styled from 'styled-components';
import * as palette from '../../styles/variables';
import { Button, Select } from 'antd';
import {
  DEFAULT_FONT,
  WHITE_COLOR,
  BLACK_COLOR,
} from '../../styles/variables';

export const Main = styled.div`
  background-color: ${WHITE_COLOR};
  height: 100vh;
  width: 100%;  
  box-sizing: border-box;
  font-family: ${DEFAULT_FONT}, sans-serif;
  font-weight: 500;
  color: ${BLACK_COLOR};  
  padding:40px 0px;
`;
export const Container = styled.div`
  background-color: transperant;
  box-sizing: border-box;
  width: calc(100vw - 15%);
  margin: auto;
  .pageTitle {
    background: ${palette.APP_BRAND_YELLOW_COLOR};
    max-width: fit-content;
    padding: 1.5rem 3rem;
    margin: 3rem auto;
    border-radius: 17px;
    font-size: 2.2rem;
    
    @media(min-width:64em){
      padding: 1.5rem 3.7rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    display: grid;
    grid-template-columns: 1fr 1fr 3.7rem
    gap: 0.7rem;
    justify-items: center;
    span{
      grid-column: span 3;
    }
    strong{
      grid-column: span 2;
    }
    img{
      width: 3.7rem;
    }
  }
  @media only screen and (max-width: 768px) {
    .pageTitle{
      font-size: 1.5rem !important;
    }
  }
  .pageSuggetion {
    background: ${palette.TRANSPARENT_COLOR};
    text-align: center;
    max-width: fit-content;   
    margin: 1rem auto;
    font-size: 1.5rem;
    .base {
      font-size: 1.15rem;
    }
  }
  .pageDirectors {
    background: ${palette.TRANSPARENT_COLOR};    
    max-width: fit-content;  
    margin: 1rem auto;
    display: flex;
    gap: 3rem;
    .director {
      background: #0c0024;
      color:#fff
      width: 13rem;
      height:5.5rem
      padding: 2.5rem 3.5rem;
      border-radius: 27px;
      font-size: 1.17rem;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      white-space: inherit;
    }
  }
`;
export const Title = styled.div`
  font-family: ${DEFAULT_FONT};
  font-size: 2.5rem;
  font-weight: 700;
  color: #000;
  padding: 1rem 1rem 0 1rem;

  &.page {
    font-size: 2rem;
    font-weight: 600;
    padding: 1rem 0 2rem;
  }

  &.sub {
    font-size: 1.25rem;
    color: #666;
    font-weight: 600;
    padding: 1.25rem 0 0.625rem;
  }
  &.head {
    font-size: 1.75rem;
    color: #000;
    font-weight: 300;
    padding: 0 0 0.25rem;
    max-width: fit-content;
    margin: 0 auto;
    &.bold {
      font-weight: 700;
    }
  }
`;

export const NavigateButton = styled.div`
  button:hover {
    cursor: pointer;
  }
  button {
    border:none;
    cursor:${props => props.disable ? 'not-allowed' : "pointer"}  
    color: #fff;
    overflow: hidden;
    position: relative; 
    display: flex;
    align-items: center !important;
    justify-content: center;
    height: 50px;
    background: #0c0024 !important;
    margin: 20px auto;
    border-radius: 15px;
    font-family: 'glacial indifference';  
    width: 100%;
    min-width: 10rem;
    max-width: 20rem;
    height:5.5rem; 
    padding: 2.5rem 3.5rem;
    border-radius: 27px;
    font-size: 1.17rem;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    white-space: inherit;
    @media only screen and (min-width: 2560px) {
      font-size: 22px;
      height: 85px;
      letter-spacing: 1.5px;
      width: 380px;
    }
  }
  button:hover:before {
    opacity: 1;
    transform: translate(0, 0);
  }
  button:before {
    padding: 2.5rem;
    content: attr(data-hover);
    position: absolute;
    left: 0;
    width: 100%;
    text-transform: uppercase;
    opacity: 0;
    transform: translate(0, 100%);
    transition: all 0.2s ease-in-out;
  }
  button:hover div {
    opacity: 0;
    transform: translate(0, -100%);
  }
  button div {
    text-transform: uppercase;
    transition: all 0.2s ease-in-out;
  }
`;

export const Section = styled.div`
  word-break: break-word !important;
  background-color: transparent;
  box-sizing: border-box;
  width: 100%;
  .createTicketForm {
    max-width: 55rem;
    margin: 1rem auto 3rem;
    .submitTicketForm {
      max-width: 77%;
      margin: 1rem auto;
      .formField {
        display: grid;
        grid-gap: 0.25rem;
        .desc-length{
          text-align:end
        }
        .fieldLable {
          color: #000;
          font-size: 1.05rem;
        }
        .required-label::after {
          content: "*";
          color: red; 
          margin-left 4px;
        }
        input {
          color: #a6a6a6;
          font-size: 0.9rem;
          font-weight: 600;
          padding: 1.5rem 0.7rem;
        }
        textarea {
          color: #a6a6a6;
          font-size: 0.9rem;
          font-weight: 600;
          padding: 0.5rem 0.7rem 1.5rem;
        }
      }
      .dropdowns {
        display: grid;
        grid-template-columns: 1fr 210px;
        .formField.one {
          justify-self: left;
        }
        .formField.two {
          justify-self: right;
        }
      }
    }
  }
  .raiseTicketActions {
    display: flex;
    justify-content: center;
    aligh-items: center;
    .submitBtn {
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 600;
      height: 2.5rem;
      border: 0 solid transparent;
      border-radius: 27px;
      cursor: pointer;
      padding: 0 3rem;
      max-width: fit-content;
      margin: 1rem auto;
      background-color: #ffde59;
      color: #000;
    }
  }
  .btns {
    display: flex;
    justify-content: center;
    aligh-items: center;
    .acceptBtn {
      text-transform: uppercase;
      font-size: 1rem;
      font-weight: 600;
      height: 2.5rem;
      border: 0 solid transparent;
      border-radius: 27px;
      cursor: pointer;
      padding: 0 3rem;
      max-width: fit-content;
      margin: 1rem auto;
      background-color: #ffde59;
      color: #000;
    }
  }
  .space {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  .ant-upload.ant-upload-drag{
    height: auto;
  }
  .uploadAttachments {
    min-height: 11rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .uploadIcon {
      font-size: 3rem;
      opacity: 0.5;
    }
    p {
      max-width: 33rem;
      margin: 0 auto 0.5rem;
    }
  }
  .actions {
    display: flex;
    gap: 1rem;
    max-width: max-content;
    margin: 0 0 0 auto;
  }

  .submitTicketBtn {
    font-weight: 500;
    font-size: 12px;
    text-transform: uppercase;
    height: 35px;
    padding: 10px 20px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    background: ${palette.LIGHT_GREEN};
    border-radius: 20px;
    color: rgb(0, 0, 0);
    text-shadow: none;
    border: 2px solid transparent;
    margin: 0 0 0 auto;
  }
  .ticketList {
    background: #f1f1f1;
    width: 100%;
    margin: 3rem 0;
    padding: 0 3rem 3rem;
    border-radius: 1.5rem;
    .ant-skeleton-title{
      width:100% !important;
      height:125px;
      border-radius:27px;
    }
    .skeleton .ant-skeleton-content .ant-skeleton-paragraph > li{       
        width:100% !important;
        height:125px;
        border-radius:27px;
    }
    .ticketListCardTitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 2rem 0;
      margin:auto;
      width:95%;
      .filters {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        .verticalSwapIcon {
          transform: rotate(90deg);
        }
      }
    
    }
    .table-wraper{     
      max-height:35rem;
    }
    .ticketsTable {
      cursor: pointer;     
      .ticket {
        .ticketInfo {
          justify-self: self-start;       
        }
        .ticketStatus img{
          width:75%;
          margin:auto;
        }
      }
      thead {
        display: none;
      }
      tbody {
        display: grid;
        grid-gap: 1rem;
        tr {
          &:hover {
            td {
              background: transparent !important;
            }
          }
          display: grid;
          border: 1px solid #e8e8e8;
          border-radius: 27px;
          background: #fff;
          // min-height: 11rem;
          padding: 0.8rem 2rem;
          td {
            border: 0;
            background: ${palette.TRANSPARENT_COLOR};
            width: 100%;
            display: flex;
            align-items: center;
            .ticket {
              width: 100%;
              display: grid;
              grid-template-columns: 4fr 0.5fr 1fr 1fr;
              justify-items: center;
              align-items: center;
              font-size: 1rem;
              .ticketInfo {
                color: #000;                              
                .subject {
                  font-weight: 700;   
                  display: flex;
                  word-break: break-word;                      
                }
              }
              .ticketPriority {
                .priority {
                  font-size: 0.8rem;
                  border-radius: 50%;
                  height: 4rem;
                  width: 4rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  color: #fff;
                  &.high {
                    background-color: #ff914d;
                  }
                  &.medium {
                    background-color: #0cc0df;
                  }
                  &.low {
                    background-color: #faad14;
                  }
                }
              }
            }
          }
        }
      }
    }    
  
    @media only screen and (max-width: 992px)   {
      tr {
        padding:1rem !important;
      }
      .ticket {
        grid-template-columns: repeat(4, 1fr) !important;
        font-size: 1rem !important;
     }
     .ticketStatus img{
      width:50% !important;
      margin: auto;
     }
     .priority {
      height: 4rem !important;
      width: 4rem !important;
      font-size: 0.8rem !important;
     }
    }
  }
  .ticketModalSection{
    word-break: break-word !important;
  }

  .ticketModal {
    display: grid;
    gap: 1rem;
    .card-details{
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    .ticketCard {
      border: 1px solid #e8e8e8;
      border-radius: 27px;
      background: #fff;
      min-height: 11rem;
      padding: 2rem 3rem;
      display: grid;
      // grid-template-columns: 1fr 1fr;
      a {
        font-size: 1rem;
        font-weight: 300;
        text-decoration: none;
        color: #014c2094;
        text-align:center !important;
      }
      .ant-list-header{
        display:none !important;
  
      }        
      .infoCard {
        border-radius: 27px;
        background: transparent;
        min-height: fit-content;
        padding: 1rem 1.5rem;
        display: flex;
        gap: 0.5rem;
        color: #000;
        font-size: 1.05rem;        
        .key {
          font-weight: 300;
          white-space: nowrap;
        }
        .value {
          font-weight: 700; 
          display: flex;
          word-break: break-word;                  
        }
        &.single {
          grid-column: span 2;
          display: grid;
        }
        &.id {
          grid-column: span 2;
          display: flex;
          font-size: 1.5rem;
        }
        &.sla {
          grid-column: span 2;
          display: flex;
        }       
        &.description,
        &.resolution {
          .key {
            font-weight: 700;
          }
          .value {
            font-weight: 300;
          }
        }
      }
      &.comments {
        grid-template-columns: 1fr;
        gap: 0.25rem;
        .ant-comment-inner {
          padding: 8px 0;
        } 
        .add-comment{
          background: #0c0024 !important;
          border:none;
        }      
      }
      .ant-upload-picture-card-wrapper{
        padding-left:1rem !important;
      }
      .ant-upload-list-picture-card-container{
        width: 134px !important;
        height: 134px !important;
      }
      .ant-upload-list-item{
        width: 134px !important;
        height: 134px !important;
      }
      .ant-upload.ant-upload-select-picture-card{
        width: 134px !important;
        height: 134px !important;
      }
      .anticon-delete {
        display: none !important;
      }
      .image-modal{
        .ant-modal-body{
          padding: 20px !important;
        }
        .view-file{
          text-align:end !important;
        }
        a {
          text-align:end !important;
        }
      }
    }   
   
  }

  .modalComments {
    .comment {
      margin-bottom: 0.5rem;
    }   
  }

  .ticket-details {
    .ant-card-grid-hoverable:hover {
      background: #f6f6f6;
    }
  }

  .custom-timeline-item {
    display: flex;
    align-items: flex-start;
  }

  .custom-timeline-content {
    display: flex;
    gap: 0.5rem;
  }

  .custom-timeline-label {
    font-weight: bold;
  }

  .custom-timeline-children,
  .custom-timeline-description {
  }

  .ant-list-empty-text{
    display:none !important;
  }
`;
export const FilterGroup = styled.div`
display: flex;
gap: 0.5rem;
justify-content: center;
alignItems: center;
`;
export const FilterPriority = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f1f1f1;
  border-radius: 7px;
  padding: 0.5rem;
  height: 37px;
  border: 0;
`;
export const FilterOpen = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  background: #f1f1f1;
  border-radius: 7px;
  padding: 0.5rem;
  height: 37px;
  border: 0;
`;
export const FilterClosed = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  background: #f1f1f1;
  border-radius: 7px;
  padding: 0.5rem;
  height: 37px;
  border: 0;

  .clear-btn{
    border: none;
    background: none;
  }
`;

export const SelectElement = styled(Select)`
  width: 170px;
`;
export const ModalFooter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  width: 100%;
  height: 100%;
  background: #f1f1f1;
  z-index: 0;
`;
